import { render, staticRenderFns } from "./QualityTap.vue?vue&type=template&id=1f38dbb7&"
import script from "./QualityTap.vue?vue&type=script&lang=js&"
export * from "./QualityTap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports